import Vue from 'vue'
import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import router from '@/router';
import qs from 'qs'
import { timestamp} from "@/utils/proof-technique.js"
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
Vue.prototype.pathImg = 'http://hry-exchange-public.oss-cn-beijing.aliyuncs.com/';
// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API , // url = base url + request url   'http://172.16.10.202:7350'
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // if (sessionStorage.getItem('token')) {
    //   config.headers.common['token'] = sessionStorage.getItem('token');
    // }
    // else{
    //   if(token != ''){
    //     config.headers.common['token'] = token
    //   }
    // }
    if(config.data.uid == "" || !config.data.uid){
      config.data["uid"] = timestamp();
    }
    if (config.method === 'post') {
      config.data = qs.stringify(config.data);
    }
    if (config.method === 'get') {
      config.url = config.url + "?" + qs.stringify(config.data);
      if(config.download){
        config.responseType = 'blob'
      }
    }
    if (config.method === 'upload') {
      config.method = 'post';
    }
    if (localStorage.getItem('token')) {
      config.headers.common['token'] = localStorage.getItem('token');     //从cookie 获取token   传到接口headers里面
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data;
    return response;
  },
  error => {
    if(error.response.status == 401){
      Message({
          message: "登录状态已过期，请重新登录！",
          type: 'error',
      });
      localStorage.removeItem("isLogin");
      localStorage.removeItem("userObj");
      localStorage.removeItem("token");
      router.push("/");
      store.commit('ChangeLoginShow');
    }else{
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js